var _path, _g, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 247,
    viewBox: "0 0 262 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.017 246.845C199.365 246.845 250.718 195.492 250.718 132.144C250.718 68.7968 199.365 17.4434 136.017 17.4434C72.6698 17.4434 21.3164 68.7968 21.3164 132.144C21.3164 195.492 72.6698 246.845 136.017 246.845Z",
    fill: "url(#paint0_linear_1614_1694)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1614_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.466 10H177.386C174.586 10 172.316 12.2696 172.316 15.0692V43.3086C172.316 46.1083 174.586 48.3778 177.386 48.3778H237.466C240.266 48.3778 242.535 46.1083 242.535 43.3086V15.0692C242.535 12.2696 240.266 10 237.466 10Z",
    fill: "url(#paint1_linear_1614_1694)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.144 35.0124C190.363 35.0124 192.972 32.4031 192.972 29.1844C192.972 25.9657 190.363 23.3564 187.144 23.3564C183.926 23.3564 181.316 25.9657 181.316 29.1844C181.316 32.4031 183.926 35.0124 187.144 35.0124Z",
    fill: "#16AFF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.972 35.0124C211.191 35.0124 213.8 32.4031 213.8 29.1844C213.8 25.9657 211.191 23.3564 207.972 23.3564C204.754 23.3564 202.145 25.9657 202.145 29.1844C202.145 32.4031 204.754 35.0124 207.972 35.0124Z",
    fill: "#16AFF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.797 35.0124C232.015 35.0124 234.625 32.4031 234.625 29.1844C234.625 25.9657 232.015 23.3564 228.797 23.3564C225.578 23.3564 222.969 25.9657 222.969 29.1844C222.969 32.4031 225.578 35.0124 228.797 35.0124Z",
    fill: "#16AFF4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 177.284,
    cy: 237.096,
    r: 6.09644,
    fill: "url(#paint2_linear_1614_1694)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7751 175.307C17.2953 175.063 18.509 176.557 17.9597 177.995L15.0497 185.615C14.5005 187.053 12.6002 187.357 11.6292 186.163L6.48526 179.833C5.5143 178.638 6.2009 176.84 7.72113 176.596L15.7751 175.307Z",
    fill: "url(#paint3_linear_1614_1694)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M237.276 168.438C236.896 166.946 238.273 165.602 239.755 166.018L247.608 168.225C249.09 168.641 249.565 170.506 248.463 171.582L242.626 177.279C241.524 178.354 239.672 177.833 239.291 176.341L237.276 168.438Z",
    fill: "url(#paint4_linear_1614_1694)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.145 8.05385C121.638 6.01293 124.541 6.01293 125.034 8.05385L126.867 15.6495C127.043 16.3789 127.613 16.9483 128.342 17.1244L135.938 18.9579C137.979 19.4506 137.979 22.3536 135.938 22.8462L128.342 24.6798C127.613 24.8558 127.043 25.4253 126.867 26.1546L125.034 33.7503C124.541 35.7912 121.638 35.7912 121.145 33.7503L119.312 26.1546C119.136 25.4253 118.566 24.8558 117.837 24.6798L110.241 22.8462C108.2 22.3536 108.2 19.4506 110.241 18.9579L117.837 17.1244C118.566 16.9483 119.136 16.3789 119.312 15.6495L121.145 8.05385Z",
    fill: "url(#paint5_linear_1614_1694)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.47 217.348C119.289 218.396 118.472 221.181 116.375 221.079L108.57 220.698C107.821 220.661 107.114 221.047 106.739 221.697L102.84 228.469C101.792 230.288 99.0069 229.47 99.1092 227.373L99.49 219.569C99.5266 218.819 99.1406 218.112 98.4905 217.738L91.7191 213.839C89.8997 212.791 90.7176 210.006 92.8147 210.108L100.619 210.489C101.369 210.525 102.075 210.139 102.45 209.489L106.349 202.718C107.397 200.898 110.182 201.716 110.08 203.813L109.699 211.618C109.663 212.367 110.049 213.074 110.699 213.449L117.47 217.348Z",
    fill: "url(#paint6_linear_1614_1694)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1614_1694)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1614_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.184 170.235C178.082 170.235 207.184 144.215 207.184 112.118C207.184 80.0202 178.082 54 142.184 54C106.285 54 77.1836 80.0202 77.1836 112.118C77.1836 124.735 81.6806 136.414 89.3197 145.942L77.1836 177.5L127.739 168.795C132.385 169.738 137.219 170.235 142.184 170.235Z",
    fill: "url(#paint7_linear_1614_1694)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_1614_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.371 180.235C166.821 180.235 195.559 154.215 195.559 122.118C195.559 90.0202 166.821 64 131.371 64C95.9213 64 67.1836 90.0202 67.1836 122.118C67.1836 134.735 71.6244 146.414 79.168 155.942L67.1836 187.5L117.107 178.795C121.695 179.737 126.469 180.235 131.371 180.235ZM121.743 125.75C121.743 131.135 126.054 135.5 131.371 135.5C136.689 135.5 140.999 131.135 140.999 125.75C140.999 120.365 136.689 116 131.371 116C126.054 116 121.743 120.365 121.743 125.75ZM153.837 125.75C153.837 129.34 156.711 132.25 160.255 132.25C163.8 132.25 166.674 129.34 166.674 125.75C166.674 122.16 163.8 119.25 160.255 119.25C156.711 119.25 153.837 122.16 153.837 125.75ZM96.068 125.75C96.068 129.34 98.9418 132.25 102.487 132.25C106.032 132.25 108.905 129.34 108.905 125.75C108.905 122.16 106.032 119.25 102.487 119.25C98.9418 119.25 96.068 122.16 96.068 125.75Z",
    fill: "white",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1614_1694",
    x: 165.316,
    y: 1,
    width: 96.2188,
    height: 64.3779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1614_1694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1614_1694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1614_1694",
    x: 63.1836,
    y: 50,
    width: 156,
    height: 149.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.180392 0 0 0 0 0.764706 0 0 0 0 0.835294 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1614_1694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1614_1694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1614_1694",
    x: 75.1836,
    y: 52,
    width: 134,
    height: 127.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1614_1694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1614_1694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_1614_1694",
    x: 59.1836,
    y: 60,
    width: 144.375,
    height: 139.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1614_1694"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1614_1694",
    result: "effect2_dropShadow_1614_1694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1614_1694",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1614_1694",
    x1: 135.133,
    y1: -19.9061,
    x2: 137.483,
    y2: 382.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5E3FF",
    stopOpacity: 0.0862745
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16AFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1614_1694",
    x1: 170.208,
    y1: 38.7787,
    x2: 271.598,
    y2: 41.7116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAEAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1614_1694",
    x1: 170.672,
    y1: 242.69,
    x2: 184.102,
    y2: 242.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16AFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEEBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1614_1694",
    x1: 0.278181,
    y1: 177.96,
    x2: 12.3775,
    y2: 192.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16AFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEEBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1614_1694",
    x1: 241.325,
    y1: 183.63,
    x2: 255.055,
    y2: 170.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16AFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEEBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1614_1694",
    x1: 100.419,
    y1: 40.0802,
    x2: 146.464,
    y2: 40.0802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16AFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEEBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1614_1694",
    x1: 92.5808,
    y1: 188.438,
    x2: 79.6076,
    y2: 232.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16AFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0E2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1614_1694",
    x1: 142.184,
    y1: 54,
    x2: 142.184,
    y2: 177.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16AFF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C82AF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSuccess);
export default __webpack_public_path__ + "static/media/contact-success.2920fa966f98440d9c7b79bdd435e2d1.svg";
export { ForwardRef as ReactComponent };